// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mail. Roots: .mail-page (the app), .mail-center (loading / empty / OAuth callback),
   .mail-folders-drawer, .mail-compose-modal and .mail-account-modal (portals). */

.mail-page {
  --mail-hover: var(--ds-bg);
  --mail-active: var(--ds-brand-tint);
  --mail-line: var(--ds-border-soft);
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  /* Fill the content area under the top bar and page header (desktop). */
  height: calc(100vh - var(--ds-topbar-h) - 2 * var(--ds-page-pad) - 72px);
  height: calc(100dvh - var(--ds-topbar-h) - 2 * var(--ds-page-pad) - 72px);
  min-height: 520px;
}

/* Phones/tablets: no page header, bottom navigation below the content. */
.mail-page--compact {
  gap: var(--ds-space-2);
  height: calc(
    100vh - var(--ds-topbar-h) - var(--ds-page-pad) - var(--ds-bottomnav-h) -
      var(--ds-safe-bottom) - var(--ds-space-4)
  );
  height: calc(
    100dvh - var(--ds-topbar-h) - var(--ds-page-pad) - var(--ds-bottomnav-h) -
      var(--ds-safe-bottom) - var(--ds-space-4)
  );
  min-height: 420px;
}

.mail-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  max-width: 520px;
  margin: 0 auto;
  padding: var(--ds-space-4);
  text-align: center;
}

.mail-page .mail-muted,
.mail-center .mail-muted,
.mail-folders-drawer .mail-muted,
.mail-compose-modal .mail-muted,
.mail-account-modal .mail-muted {
  color: var(--ds-text-muted);
}

/* ── Header ─────────────────────────────────────────────── */
.mail-page .mail-header {
  margin-bottom: 0;
}

.mail-page .mail-account-select,
.mail-folders-drawer .mail-account-select {
  width: 100%;
  min-width: 0;
}

@media (min-width: 768px) {
  .mail-page .mail-header .page-toolbar__filters > * {
    flex: 0 1 360px;
  }
}

.mail-page .mail-mobilebar {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
}

.mail-page .mail-mobilebar-folder {
  flex: 1 1 auto;
  min-width: 0;
  justify-content: flex-start;
}

.mail-page .mail-mobilebar-folder-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
}

.mail-page .mail-panes {
  display: flex;
  flex: 1;
  min-height: 0;
  background: var(--ds-surface);
  border: 1px solid var(--mail-line);
  border-radius: var(--ds-radius-md);
  overflow: hidden;
}

/* ── Folders (desktop pane and phone drawer) ────────────── */
.mail-page .mail-folders {
  width: 220px;
  flex-shrink: 0;
  padding: var(--ds-space-3);
  border-inline-end: 1px solid var(--mail-line);
  overflow-y: auto;
  background: var(--ds-bg);
}

.mail-folders-drawer .mail-folders {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
}

.mail-page .mail-folders-compose {
  margin-bottom: var(--ds-space-3);
}

.mail-page .mail-folder-list,
.mail-folders-drawer .mail-folder-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mail-page .mail-folder,
.mail-folders-drawer .mail-folder {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-height: 36px;
  padding-block: 4px;
  padding-inline-end: 4px;
  border-radius: var(--ds-radius-sm);
  cursor: pointer;
  color: var(--ds-text);
  user-select: none;
}

.mail-folders-drawer .mail-folder {
  min-height: var(--ds-touch);
}

.mail-page .mail-folder:hover,
.mail-folders-drawer .mail-folder:hover {
  background: var(--ds-surface-muted);
}

.mail-page .mail-folder.active,
.mail-folders-drawer .mail-folder.active {
  background: var(--ds-brand-tint);
  color: var(--ds-brand-dark);
  font-weight: 600;
}

.mail-page .mail-folder.disabled,
.mail-folders-drawer .mail-folder.disabled {
  cursor: default;
  color: var(--ds-text-muted);
  background: transparent;
}

.mail-page .mail-folder-icon,
.mail-folders-drawer .mail-folder-icon {
  display: inline-flex;
  font-size: 15px;
}

.mail-page .mail-folder-name,
.mail-folders-drawer .mail-folder-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Folder menu: revealed on hover with a mouse, always visible on touch screens. */
.mail-page .mail-folder-more {
  opacity: 0;
}

.mail-page .mail-folder:hover .mail-folder-more,
.mail-page .mail-folder-more:focus-visible,
.mail-page .mail-folder-more.ant-dropdown-open {
  opacity: 1;
}

@media (hover: none) {
  .mail-page .mail-folder-more {
    opacity: 1;
  }
}

.mail-folders-drawer .mail-folder-more {
  min-width: var(--ds-touch);
  height: var(--ds-touch);
}

.mail-page .mail-folder-add,
.mail-folders-drawer .mail-folder-add {
  margin-top: var(--ds-space-2);
  justify-content: flex-start;
  color: var(--ds-text-2);
}

/* ── Message list ───────────────────────────────────────── */
.mail-page .mail-list {
  width: 380px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-inline-end: 1px solid var(--mail-line);
  min-height: 0;
  min-width: 0;
}

.mail-page .mail-list-toolbar {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  padding: var(--ds-space-3) var(--ds-space-3) var(--ds-space-2);
}

.mail-page .mail-list-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 36px;
  padding-inline: 20px var(--ds-space-3);
  border-bottom: 1px solid var(--mail-line);
}

.mail-page .mail-list-spin {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mail-page .mail-items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mail-page .mail-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding-block: 10px;
  padding-inline: 20px var(--ds-space-3);
  border-bottom: 1px solid var(--mail-line);
  cursor: pointer;
  position: relative;
}

.mail-page .mail-item:hover {
  background: var(--mail-hover);
}

.mail-page .mail-item.active {
  background: var(--mail-active);
}

.mail-page .mail-item.unread::before {
  content: "";
  position: absolute;
  inset-inline-start: 7px;
  top: 16px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--ds-brand-dark);
}

.mail-page .mail-item-from,
.mail-page .mail-item-subject {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ds-text);
}

.mail-page .mail-item.unread .mail-item-from,
.mail-page .mail-item.unread .mail-item-subject {
  font-weight: 600;
  color: var(--ds-text);
}

.mail-page .mail-item-star {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 1px 0 0;
  border: 0;
  background: transparent;
  color: var(--ds-text-muted);
  font-size: 14px;
  cursor: pointer;
}

.mail-page .mail-item-star.on {
  color: var(--mail-star);
}

.mail-page .mail-item-star:focus-visible {
  outline: none;
  box-shadow: var(--ds-focus-ring);
  border-radius: var(--ds-radius-sm);
}

.mail-page .mail-check {
  display: inline-flex;
  align-items: center;
}

.mail-page .mail-item-body {
  flex: 1;
  min-width: 0;
}

.mail-page .mail-item-top {
  display: flex;
  justify-content: space-between;
  gap: var(--ds-space-2);
}

.mail-page .mail-item-subject {
  font-size: 13px;
  color: var(--ds-text-2);
}

.mail-page .mail-item-date {
  flex-shrink: 0;
  font-size: 12px;
  color: var(--ds-text-muted);
}

.mail-page .mail-item-answered {
  margin-inline-end: 6px;
  font-size: 11px;
  color: var(--ds-text-muted);
}

.mail-page .mail-item-clip {
  margin-inline-start: 6px;
  color: var(--ds-text-muted);
}

.mail-page .mail-live-dot {
  display: inline-block;
  margin-inline: 4px 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ds-border);
}

.mail-page .mail-live-dot.on {
  background: var(--mail-success);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--mail-success) 20%, transparent);
}

.mail-page .mail-pagination {
  padding: var(--ds-space-2) var(--ds-space-3);
  border-top: 1px solid var(--mail-line);
  text-align: center;
}

/* ── Reader ─────────────────────────────────────────────── */
.mail-page .mail-reader-pane {
  flex: 1;
  min-width: 0;
  display: flex;
}

.mail-page .mail-reader,
.mail-page .mail-reader-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.mail-page .mail-reader {
  overflow-y: auto;
}

.mail-page .mail-reader-empty {
  align-items: center;
  justify-content: center;
}

.mail-page .mail-reader-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
  padding: 10px var(--ds-space-4);
  border-bottom: 1px solid var(--mail-line);
  background: var(--ds-surface);
}

.mail-page .mail-reader-header {
  padding: var(--ds-space-4) var(--ds-space-4) var(--ds-space-2);
}

.mail-page .mail-reader-subject {
  margin: 0 0 var(--ds-space-3);
  font-size: 18px;
  overflow-wrap: anywhere;
}

.mail-page .mail-reader-meta {
  display: flex;
  gap: var(--ds-space-3);
  align-items: flex-start;
}

.mail-page .mail-reader-people {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.mail-page .mail-reader-date {
  flex-shrink: 0;
  font-size: 12px;
}

.mail-page .mail-reader-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: var(--ds-space-3);
}

.mail-page .mail-attachment-chip {
  max-width: 100%;
  margin: 0;
  padding: 4px 10px;
  font-size: 13px;
  white-space: normal;
  overflow-wrap: anywhere;
  cursor: pointer;
}

.mail-page .mail-attachment-chip:hover {
  border-color: var(--ds-brand-dark);
  color: var(--ds-brand-dark);
}

.mail-page .mail-body-frame,
.mail-compose-modal .mail-body-frame {
  flex: 1;
  width: 100%;
  min-height: 200px;
  border: 0;
  border-top: 1px solid var(--mail-line, var(--ds-border-soft));
  background: var(--ds-surface);
}

/* ── Compose (modal portal) ─────────────────────────────── */
.mail-compose-modal .mail-compose-fields {
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-sm);
  margin-bottom: var(--ds-space-3);
}

.mail-compose-modal .mail-compose-row {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  padding: 2px 10px;
  border-bottom: 1px solid var(--ds-border-soft);
  min-height: 40px;
}

.mail-compose-modal .mail-compose-row:last-child {
  border-bottom: 0;
}

.mail-compose-modal .mail-compose-label {
  width: 64px;
  flex-shrink: 0;
  color: var(--ds-text-muted);
}

.mail-compose-modal .mail-compose-from {
  min-width: 0;
  padding: 4px 11px;
  overflow-wrap: anywhere;
}

.mail-compose-modal .mail-compose-editor .ql-container {
  min-height: 240px;
  font-size: 14px;
}

.mail-compose-modal .mail-compose-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: var(--ds-space-3);
}

.mail-compose-modal .mail-compose-attachments .ant-tag {
  max-width: 100%;
  margin: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}

.mail-compose-modal .mail-compose-quote {
  margin-top: var(--ds-space-3);
}

.mail-compose-modal .mail-compose-quote .mail-body-frame {
  margin-top: var(--ds-space-2);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-sm);
}

.mail-compose-modal .mail-compose-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--ds-space-2);
  width: 100%;
}

.mail-compose-modal .mail-compose-footer-send {
  display: flex;
  gap: var(--ds-space-2);
  margin-inline-start: auto;
}

[dir="rtl"] .mail-page .mail-back .anticon {
  transform: scaleX(-1);
}

/* ── Phones and tablets: one pane at a time ─────────────── */
.mail-page--compact .mail-list {
  width: 100%;
  border-inline-end: 0;
}

.mail-page--compact .mail-list-toolbar {
  padding: var(--ds-space-2) var(--ds-space-3);
}

.mail-page--compact .mail-list-actions {
  min-height: var(--ds-touch);
  padding-inline: var(--ds-space-2);
}

.mail-page--compact .mail-item {
  align-items: center;
  gap: 4px;
  padding-block: var(--ds-space-2);
  padding-inline: var(--ds-space-4) var(--ds-space-3);
}

.mail-page--compact .mail-item.unread::before {
  inset-inline-start: 5px;
  top: 50%;
  margin-top: -3px;
}

/* 40px+ hit areas for the row checkbox and star: the checkbox label fills its wrapper. */
.mail-page--compact .mail-check {
  display: inline-flex;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}

.mail-page--compact .mail-check > .ant-checkbox-wrapper {
  flex: 1;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.mail-page--compact .mail-item-star {
  min-width: 40px;
  min-height: 40px;
  padding: 0;
  font-size: 18px;
}

.mail-page--compact .mail-reader-toolbar {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: var(--ds-space-2);
}

.mail-page--compact .mail-reader-header {
  padding-inline: var(--ds-space-3);
}

/* The reader scrolls as a whole on small screens; give the message room to read. */
.mail-page--compact .mail-body-frame {
  flex: 1 0 auto;
  min-height: 60vh;
  min-height: 60dvh;
}

@media (max-width: 575.98px) {
  .mail-page .mail-btn-label {
    display: none;
  }

  .mail-page .mail-reader-meta {
    flex-wrap: wrap;
  }

  .mail-page .mail-reader-date {
    width: 100%;
    order: -1;
  }

  .mail-compose-modal .mail-compose-label {
    width: 52px;
  }
}

/* ── Mail assistant ─────────────────────────────────────── */
.mail-page .mail-list-assistant {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 6px var(--ds-space-3);
  border-bottom: 1px solid var(--mail-line);
}

.mail-page .mail-category-select {
  min-width: 130px;
  flex: 1;
}

.mail-page .mail-item-assistant {
  margin-top: 3px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  align-items: center;
  font-size: 12px;
}

.mail-page .mail-item-assistant .ant-tag {
  margin-inline-end: 2px;
  font-size: 11px;
  line-height: 18px;
  padding-inline: 5px;
}

.mail-page .mail-assistant {
  margin: 0 var(--ds-space-4) var(--ds-space-3);
  padding: 10px var(--ds-space-3);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  background: var(--ds-bg);
}

.mail-page .mail-assistant--compact {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
  font-size: 13px;
}

.mail-page .mail-assistant-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--ds-space-2);
  margin-bottom: 6px;
}

.mail-page .mail-assistant-icon {
  color: var(--ds-brand-dark);
  font-size: 16px;
  margin-inline-end: 2px;
}

.mail-page .mail-assistant-points {
  margin: 0 0 6px;
  padding-inline-start: 18px;
}

.mail-page .mail-assistant-note {
  font-size: 12px;
}

.mail-page .mail-assistant-sections {
  margin-top: 6px;
}

/* antd's ghost Collapse sets its own header/content padding with higher specificity. */
.mail-page .mail-assistant-sections > .ant-collapse-item > .ant-collapse-header {
  padding-inline: 0;
  font-weight: 600;
}

.mail-page
  .mail-assistant-sections
  > .ant-collapse-item
  > .ant-collapse-content
  > .ant-collapse-content-box {
  padding-inline: 0;
}

.mail-page .mail-assistant-reply {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-sm);
  padding: var(--ds-space-2) 10px;
  max-height: 260px;
  overflow: auto;
  font-size: 13px;
}

.mail-page .mail-assistant-file {
  padding: 6px 0;
  border-top: 1px solid var(--ds-border-soft);
}

.mail-page .mail-assistant-file:first-child {
  border-top: 0;
}

.mail-page .mail-assistant-file-head {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.mail-page .mail-assistant-file-name {
  max-width: 45%;
}

.mail-page .mail-assistant-saved {
  color: var(--mail-success);
}

.mail-page .mail-assistant-file-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  margin-block: 6px 2px;
  margin-inline-start: 22px;
}

.mail-page .mail-assistant-path {
  width: 100%;
}

@media (max-width: 767.98px) {
  .mail-page .mail-assistant {
    margin: 0 var(--ds-space-2) 10px;
  }

  .mail-page .mail-assistant-file-fields {
    grid-template-columns: 1fr;
    margin-inline-start: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/mail/Mail.css"],"names":[],"mappings":"AAAA;iFACiF;;AAEjF;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,uEAAuE;EACvE,wEAAwE;EACxE,yEAAyE;EACzE,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,sBAAsB;EACtB;;;GAGC;EACD;;;GAGC;EACD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,6CAA6C;EAC7C,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,8EAA8E;AAChF;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;EAEE,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D;EACE,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,yFAAyF;AACzF;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mFAAmF;AACnF;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,uFAAuF;AACvF;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF","sourcesContent":["/* Mail. Roots: .mail-page (the app), .mail-center (loading / empty / OAuth callback),\n   .mail-folders-drawer, .mail-compose-modal and .mail-account-modal (portals). */\n\n.mail-page {\n  --mail-hover: var(--ds-bg);\n  --mail-active: var(--ds-brand-tint);\n  --mail-line: var(--ds-border-soft);\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n  /* Fill the content area under the top bar and page header (desktop). */\n  height: calc(100vh - var(--ds-topbar-h) - 2 * var(--ds-page-pad) - 72px);\n  height: calc(100dvh - var(--ds-topbar-h) - 2 * var(--ds-page-pad) - 72px);\n  min-height: 520px;\n}\n\n/* Phones/tablets: no page header, bottom navigation below the content. */\n.mail-page--compact {\n  gap: var(--ds-space-2);\n  height: calc(\n    100vh - var(--ds-topbar-h) - var(--ds-page-pad) - var(--ds-bottomnav-h) -\n      var(--ds-safe-bottom) - var(--ds-space-4)\n  );\n  height: calc(\n    100dvh - var(--ds-topbar-h) - var(--ds-page-pad) - var(--ds-bottomnav-h) -\n      var(--ds-safe-bottom) - var(--ds-space-4)\n  );\n  min-height: 420px;\n}\n\n.mail-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  max-width: 520px;\n  margin: 0 auto;\n  padding: var(--ds-space-4);\n  text-align: center;\n}\n\n.mail-page .mail-muted,\n.mail-center .mail-muted,\n.mail-folders-drawer .mail-muted,\n.mail-compose-modal .mail-muted,\n.mail-account-modal .mail-muted {\n  color: var(--ds-text-muted);\n}\n\n/* ── Header ─────────────────────────────────────────────── */\n.mail-page .mail-header {\n  margin-bottom: 0;\n}\n\n.mail-page .mail-account-select,\n.mail-folders-drawer .mail-account-select {\n  width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .mail-page .mail-header .page-toolbar__filters > * {\n    flex: 0 1 360px;\n  }\n}\n\n.mail-page .mail-mobilebar {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.mail-page .mail-mobilebar-folder {\n  flex: 1 1 auto;\n  min-width: 0;\n  justify-content: flex-start;\n}\n\n.mail-page .mail-mobilebar-folder-name {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: start;\n}\n\n.mail-page .mail-panes {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  background: var(--ds-surface);\n  border: 1px solid var(--mail-line);\n  border-radius: var(--ds-radius-md);\n  overflow: hidden;\n}\n\n/* ── Folders (desktop pane and phone drawer) ────────────── */\n.mail-page .mail-folders {\n  width: 220px;\n  flex-shrink: 0;\n  padding: var(--ds-space-3);\n  border-inline-end: 1px solid var(--mail-line);\n  overflow-y: auto;\n  background: var(--ds-bg);\n}\n\n.mail-folders-drawer .mail-folders {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n}\n\n.mail-page .mail-folders-compose {\n  margin-bottom: var(--ds-space-3);\n}\n\n.mail-page .mail-folder-list,\n.mail-folders-drawer .mail-folder-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.mail-page .mail-folder,\n.mail-folders-drawer .mail-folder {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-height: 36px;\n  padding-block: 4px;\n  padding-inline-end: 4px;\n  border-radius: var(--ds-radius-sm);\n  cursor: pointer;\n  color: var(--ds-text);\n  user-select: none;\n}\n\n.mail-folders-drawer .mail-folder {\n  min-height: var(--ds-touch);\n}\n\n.mail-page .mail-folder:hover,\n.mail-folders-drawer .mail-folder:hover {\n  background: var(--ds-surface-muted);\n}\n\n.mail-page .mail-folder.active,\n.mail-folders-drawer .mail-folder.active {\n  background: var(--ds-brand-tint);\n  color: var(--ds-brand-dark);\n  font-weight: 600;\n}\n\n.mail-page .mail-folder.disabled,\n.mail-folders-drawer .mail-folder.disabled {\n  cursor: default;\n  color: var(--ds-text-muted);\n  background: transparent;\n}\n\n.mail-page .mail-folder-icon,\n.mail-folders-drawer .mail-folder-icon {\n  display: inline-flex;\n  font-size: 15px;\n}\n\n.mail-page .mail-folder-name,\n.mail-folders-drawer .mail-folder-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Folder menu: revealed on hover with a mouse, always visible on touch screens. */\n.mail-page .mail-folder-more {\n  opacity: 0;\n}\n\n.mail-page .mail-folder:hover .mail-folder-more,\n.mail-page .mail-folder-more:focus-visible,\n.mail-page .mail-folder-more.ant-dropdown-open {\n  opacity: 1;\n}\n\n@media (hover: none) {\n  .mail-page .mail-folder-more {\n    opacity: 1;\n  }\n}\n\n.mail-folders-drawer .mail-folder-more {\n  min-width: var(--ds-touch);\n  height: var(--ds-touch);\n}\n\n.mail-page .mail-folder-add,\n.mail-folders-drawer .mail-folder-add {\n  margin-top: var(--ds-space-2);\n  justify-content: flex-start;\n  color: var(--ds-text-2);\n}\n\n/* ── Message list ───────────────────────────────────────── */\n.mail-page .mail-list {\n  width: 380px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  border-inline-end: 1px solid var(--mail-line);\n  min-height: 0;\n  min-width: 0;\n}\n\n.mail-page .mail-list-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  padding: var(--ds-space-3) var(--ds-space-3) var(--ds-space-2);\n}\n\n.mail-page .mail-list-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 36px;\n  padding-inline: 20px var(--ds-space-3);\n  border-bottom: 1px solid var(--mail-line);\n}\n\n.mail-page .mail-list-spin {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mail-page .mail-items {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.mail-page .mail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding-block: 10px;\n  padding-inline: 20px var(--ds-space-3);\n  border-bottom: 1px solid var(--mail-line);\n  cursor: pointer;\n  position: relative;\n}\n\n.mail-page .mail-item:hover {\n  background: var(--mail-hover);\n}\n\n.mail-page .mail-item.active {\n  background: var(--mail-active);\n}\n\n.mail-page .mail-item.unread::before {\n  content: \"\";\n  position: absolute;\n  inset-inline-start: 7px;\n  top: 16px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--ds-brand-dark);\n}\n\n.mail-page .mail-item-from,\n.mail-page .mail-item-subject {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--ds-text);\n}\n\n.mail-page .mail-item.unread .mail-item-from,\n.mail-page .mail-item.unread .mail-item-subject {\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n.mail-page .mail-item-star {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 1px 0 0;\n  border: 0;\n  background: transparent;\n  color: var(--ds-text-muted);\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.mail-page .mail-item-star.on {\n  color: var(--mail-star);\n}\n\n.mail-page .mail-item-star:focus-visible {\n  outline: none;\n  box-shadow: var(--ds-focus-ring);\n  border-radius: var(--ds-radius-sm);\n}\n\n.mail-page .mail-check {\n  display: inline-flex;\n  align-items: center;\n}\n\n.mail-page .mail-item-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.mail-page .mail-item-top {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n}\n\n.mail-page .mail-item-subject {\n  font-size: 13px;\n  color: var(--ds-text-2);\n}\n\n.mail-page .mail-item-date {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.mail-page .mail-item-answered {\n  margin-inline-end: 6px;\n  font-size: 11px;\n  color: var(--ds-text-muted);\n}\n\n.mail-page .mail-item-clip {\n  margin-inline-start: 6px;\n  color: var(--ds-text-muted);\n}\n\n.mail-page .mail-live-dot {\n  display: inline-block;\n  margin-inline: 4px 6px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--ds-border);\n}\n\n.mail-page .mail-live-dot.on {\n  background: var(--mail-success);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--mail-success) 20%, transparent);\n}\n\n.mail-page .mail-pagination {\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border-top: 1px solid var(--mail-line);\n  text-align: center;\n}\n\n/* ── Reader ─────────────────────────────────────────────── */\n.mail-page .mail-reader-pane {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n}\n\n.mail-page .mail-reader,\n.mail-page .mail-reader-empty {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n}\n\n.mail-page .mail-reader {\n  overflow-y: auto;\n}\n\n.mail-page .mail-reader-empty {\n  align-items: center;\n  justify-content: center;\n}\n\n.mail-page .mail-reader-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n  padding: 10px var(--ds-space-4);\n  border-bottom: 1px solid var(--mail-line);\n  background: var(--ds-surface);\n}\n\n.mail-page .mail-reader-header {\n  padding: var(--ds-space-4) var(--ds-space-4) var(--ds-space-2);\n}\n\n.mail-page .mail-reader-subject {\n  margin: 0 0 var(--ds-space-3);\n  font-size: 18px;\n  overflow-wrap: anywhere;\n}\n\n.mail-page .mail-reader-meta {\n  display: flex;\n  gap: var(--ds-space-3);\n  align-items: flex-start;\n}\n\n.mail-page .mail-reader-people {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  overflow-wrap: anywhere;\n}\n\n.mail-page .mail-reader-date {\n  flex-shrink: 0;\n  font-size: 12px;\n}\n\n.mail-page .mail-reader-attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: var(--ds-space-3);\n}\n\n.mail-page .mail-attachment-chip {\n  max-width: 100%;\n  margin: 0;\n  padding: 4px 10px;\n  font-size: 13px;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  cursor: pointer;\n}\n\n.mail-page .mail-attachment-chip:hover {\n  border-color: var(--ds-brand-dark);\n  color: var(--ds-brand-dark);\n}\n\n.mail-page .mail-body-frame,\n.mail-compose-modal .mail-body-frame {\n  flex: 1;\n  width: 100%;\n  min-height: 200px;\n  border: 0;\n  border-top: 1px solid var(--mail-line, var(--ds-border-soft));\n  background: var(--ds-surface);\n}\n\n/* ── Compose (modal portal) ─────────────────────────────── */\n.mail-compose-modal .mail-compose-fields {\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-sm);\n  margin-bottom: var(--ds-space-3);\n}\n\n.mail-compose-modal .mail-compose-row {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  padding: 2px 10px;\n  border-bottom: 1px solid var(--ds-border-soft);\n  min-height: 40px;\n}\n\n.mail-compose-modal .mail-compose-row:last-child {\n  border-bottom: 0;\n}\n\n.mail-compose-modal .mail-compose-label {\n  width: 64px;\n  flex-shrink: 0;\n  color: var(--ds-text-muted);\n}\n\n.mail-compose-modal .mail-compose-from {\n  min-width: 0;\n  padding: 4px 11px;\n  overflow-wrap: anywhere;\n}\n\n.mail-compose-modal .mail-compose-editor .ql-container {\n  min-height: 240px;\n  font-size: 14px;\n}\n\n.mail-compose-modal .mail-compose-attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: var(--ds-space-3);\n}\n\n.mail-compose-modal .mail-compose-attachments .ant-tag {\n  max-width: 100%;\n  margin: 0;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.mail-compose-modal .mail-compose-quote {\n  margin-top: var(--ds-space-3);\n}\n\n.mail-compose-modal .mail-compose-quote .mail-body-frame {\n  margin-top: var(--ds-space-2);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-sm);\n}\n\n.mail-compose-modal .mail-compose-footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  width: 100%;\n}\n\n.mail-compose-modal .mail-compose-footer-send {\n  display: flex;\n  gap: var(--ds-space-2);\n  margin-inline-start: auto;\n}\n\n[dir=\"rtl\"] .mail-page .mail-back .anticon {\n  transform: scaleX(-1);\n}\n\n/* ── Phones and tablets: one pane at a time ─────────────── */\n.mail-page--compact .mail-list {\n  width: 100%;\n  border-inline-end: 0;\n}\n\n.mail-page--compact .mail-list-toolbar {\n  padding: var(--ds-space-2) var(--ds-space-3);\n}\n\n.mail-page--compact .mail-list-actions {\n  min-height: var(--ds-touch);\n  padding-inline: var(--ds-space-2);\n}\n\n.mail-page--compact .mail-item {\n  align-items: center;\n  gap: 4px;\n  padding-block: var(--ds-space-2);\n  padding-inline: var(--ds-space-4) var(--ds-space-3);\n}\n\n.mail-page--compact .mail-item.unread::before {\n  inset-inline-start: 5px;\n  top: 50%;\n  margin-top: -3px;\n}\n\n/* 40px+ hit areas for the row checkbox and star: the checkbox label fills its wrapper. */\n.mail-page--compact .mail-check {\n  display: inline-flex;\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n}\n\n.mail-page--compact .mail-check > .ant-checkbox-wrapper {\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n}\n\n.mail-page--compact .mail-item-star {\n  min-width: 40px;\n  min-height: 40px;\n  padding: 0;\n  font-size: 18px;\n}\n\n.mail-page--compact .mail-reader-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: var(--ds-space-2);\n}\n\n.mail-page--compact .mail-reader-header {\n  padding-inline: var(--ds-space-3);\n}\n\n/* The reader scrolls as a whole on small screens; give the message room to read. */\n.mail-page--compact .mail-body-frame {\n  flex: 1 0 auto;\n  min-height: 60vh;\n  min-height: 60dvh;\n}\n\n@media (max-width: 575.98px) {\n  .mail-page .mail-btn-label {\n    display: none;\n  }\n\n  .mail-page .mail-reader-meta {\n    flex-wrap: wrap;\n  }\n\n  .mail-page .mail-reader-date {\n    width: 100%;\n    order: -1;\n  }\n\n  .mail-compose-modal .mail-compose-label {\n    width: 52px;\n  }\n}\n\n/* ── Mail assistant ─────────────────────────────────────── */\n.mail-page .mail-list-assistant {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 6px var(--ds-space-3);\n  border-bottom: 1px solid var(--mail-line);\n}\n\n.mail-page .mail-category-select {\n  min-width: 130px;\n  flex: 1;\n}\n\n.mail-page .mail-item-assistant {\n  margin-top: 3px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  align-items: center;\n  font-size: 12px;\n}\n\n.mail-page .mail-item-assistant .ant-tag {\n  margin-inline-end: 2px;\n  font-size: 11px;\n  line-height: 18px;\n  padding-inline: 5px;\n}\n\n.mail-page .mail-assistant {\n  margin: 0 var(--ds-space-4) var(--ds-space-3);\n  padding: 10px var(--ds-space-3);\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-bg);\n}\n\n.mail-page .mail-assistant--compact {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n  font-size: 13px;\n}\n\n.mail-page .mail-assistant-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--ds-space-2);\n  margin-bottom: 6px;\n}\n\n.mail-page .mail-assistant-icon {\n  color: var(--ds-brand-dark);\n  font-size: 16px;\n  margin-inline-end: 2px;\n}\n\n.mail-page .mail-assistant-points {\n  margin: 0 0 6px;\n  padding-inline-start: 18px;\n}\n\n.mail-page .mail-assistant-note {\n  font-size: 12px;\n}\n\n.mail-page .mail-assistant-sections {\n  margin-top: 6px;\n}\n\n/* antd's ghost Collapse sets its own header/content padding with higher specificity. */\n.mail-page .mail-assistant-sections > .ant-collapse-item > .ant-collapse-header {\n  padding-inline: 0;\n  font-weight: 600;\n}\n\n.mail-page\n  .mail-assistant-sections\n  > .ant-collapse-item\n  > .ant-collapse-content\n  > .ant-collapse-content-box {\n  padding-inline: 0;\n}\n\n.mail-page .mail-assistant-reply {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-sm);\n  padding: var(--ds-space-2) 10px;\n  max-height: 260px;\n  overflow: auto;\n  font-size: 13px;\n}\n\n.mail-page .mail-assistant-file {\n  padding: 6px 0;\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.mail-page .mail-assistant-file:first-child {\n  border-top: 0;\n}\n\n.mail-page .mail-assistant-file-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.mail-page .mail-assistant-file-name {\n  max-width: 45%;\n}\n\n.mail-page .mail-assistant-saved {\n  color: var(--mail-success);\n}\n\n.mail-page .mail-assistant-file-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n  margin-block: 6px 2px;\n  margin-inline-start: 22px;\n}\n\n.mail-page .mail-assistant-path {\n  width: 100%;\n}\n\n@media (max-width: 767.98px) {\n  .mail-page .mail-assistant {\n    margin: 0 var(--ds-space-2) 10px;\n  }\n\n  .mail-page .mail-assistant-file-fields {\n    grid-template-columns: 1fr;\n    margin-inline-start: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
